//TODO: this uses the STRING "erorr" like a boolean. There's no need for it. It should just be a boolean. (this will require change in all the places that uses this function_
export const handleDropdownState = <T extends unknown>(value: T | null | undefined, error: string) => {
  if ((value || typeof value === 'number') && !error) {
    return 'Validated'
  } else {
    return error ? 'Errored' : ''
  }
}
